
export const translations = {
    en: {
        common: {
            loading: "Loading...",
            error: "Something went wrong",
            back: "Back",
            submit: "Submit",
            save: "Save",
            retry: "Try Again",
            cancel: "Cancel",
        },
        errors: {
            network: "Connection issue. Please check your internet.",
            auth: "Session expired. Please refresh the page.",
            validation: "Please check your input and try again.",
            generic: "Something went wrong. Please try again.",
            addName: "Failed to add your name",
            submitRsvp: "Failed to submit RSVP",
            saveDetails: "Failed to save details",
            uploadPhoto: "Failed to upload photo",
        },
        dashboard: {
            namaste: "Namaste",
            invited: "You're invited to celebrate with us",
            switchGuest: "Switch Guest",
            daysToGo: "Days to Go",
            latestAnnouncement: "Latest Announcement",
            explore: "Explore",
            menu: {
                rsvp: "RSVP",
                events: "Events",
                logistics: "Logistics",
                updates: "Updates",
                gallery: "Gallery",
                venue: "Venue",
            }
        },
        rsvp: {
            title: "RSVP",
            attending: "Will you be attending?",
            yes: "Yes, fully attending",
            no: "No, cannot attend",
            dietary: "Dietary Restrictions",
            notes: "Any other notes?",
            saved: "RSVP Saved",
            thanks: "Thank you for your response!",
        },
        logistics: {
            title: "Travel & Stay",
            arrival: "Arrival",
            departure: "Departure",
            transport: "Transportation",
            accommodation: "Accommodation",
            flight: "Flight",
            train: "Train",
            car: "Car",
            details: "Enter your travel details",
            saved: "Check-in details saved!",
        },
        updates: {
            title: "Updates",
            noUpdates: "No updates yet",
            readMore: "Read More",
        },
        invite: {
            title: "Your Invitation",
            family: "Family",
            members: "Members",
        },
        info: {
            title: "Info & Details",
            subtitle: "Everything you need to know",
            families: "Meet the Families",
            travelHub: "Travel Hub",
            gallery: "Photo Gallery",
            notifications: "Stay Updated",
            comingSoon: "Coming Soon",
        },
        schedule: {
            title: "Wedding Schedule",
            subtitle: "Mark your calendar",
            day: "Day",
            events: "Events",
            viewDetails: "View Details",
        },
    },
    hi: {
        common: {
            loading: "लोड हो रहा है...",
            error: "कुछ गलत हो गया",
            back: "वापस",
            submit: "जमा करें",
            save: "सहेजें",
            retry: "पुनः प्रयास करें",
            cancel: "रद्द करें",
        },
        errors: {
            network: "कनेक्शन समस्या। कृपया अपना इंटरनेट जांचें।",
            auth: "सत्र समाप्त। कृपया पृष्ठ रीफ्रेश करें।",
            validation: "कृपया अपना इनपुट जांचें और पुनः प्रयास करें।",
            generic: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
            addName: "नाम जोड़ने में विफल",
            submitRsvp: "RSVP सबमिट करने में विफल",
            saveDetails: "विवरण सहेजने में विफल",
            uploadPhoto: "फोटो अपलोड करने में विफल",
        },
        dashboard: {
            namaste: "नमस्ते",
            invited: "आप हमारे जश्न में आमंत्रित हैं",
            switchGuest: "अतिथि बदलें",
            daysToGo: "दिन शेष",
            latestAnnouncement: "ताज़ा ख़बर",
            explore: "देखें",
            menu: {
                rsvp: "आरएसवीपी (RSVP)",
                events: "कार्यक्रम",
                logistics: "यात्रा",
                updates: "अपडेट्स",
                gallery: "तस्वीरें",
                venue: "स्थान",
            }
        },
        rsvp: {
            title: "पुष्टि करें (RSVP)",
            attending: "क्या आप आ रहे हैं?",
            yes: "हाँ, हम आ रहे हैं",
            no: "नहीं, हम नहीं आ पाएंगे",
            dietary: "खाने की प्राथमिकता",
            notes: "कोई अन्य बात?",
            saved: "सहेज लिया गया",
            thanks: "आपकी प्रतिक्रिया के लिए धन्यवाद!",
        },
        logistics: {
            title: "यात्रा और निवास",
            arrival: "आगमन",
            departure: "प्रस्थान",
            transport: "यातायात",
            accommodation: "आवास",
            flight: "विमान",
            train: "रेलगाड़ी",
            car: "गाड़ी",
            details: "अपनी यात्रा का विवरण दें",
            saved: "चेक-इन विवरण सहेजा गया!",
        },
        updates: {
            title: "अपडेट्स",
            noUpdates: "अभी कोई अपडेट नहीं है",
            readMore: "और पढ़ें",
        },
        invite: {
            title: "आपका निमंत्रण",
            family: "परिवार",
            members: "सदस्य",
        },
        info: {
            title: "जानकारी",
            subtitle: "सब कुछ जो आपको जानना चाहिए",
            families: "परिवार से मिलें",
            travelHub: "यात्रा केंद्र",
            gallery: "फोटो गैलरी",
            notifications: "अपडेट रहें",
            comingSoon: "जल्द आ रहा है",
        },
        schedule: {
            title: "विवाह कार्यक्रम",
            subtitle: "अपना कैलेंडर चिह्नित करें",
            day: "दिन",
            events: "कार्यक्रम",
            viewDetails: "विवरण देखें",
        },
    }
};
